module.exports = __webpack_public_path__ + "img/banner-nosotros-mobile-min.f7d34260.jpg";